import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlogsRoutingModule } from './blogs-routing.module';
import { BlogsComponent } from './blogs.component';
import { AppCommonModule } from '@root/common/common.module';
import { ViewAllBlogsComponent } from './view-all-blogs/view-all-blogs.component';
import { BlogService } from './blog.service';
import { BlogContentComponent } from './blog-content/blog-content.component';
import { YouTubePlayer, YouTubePlayerModule } from '@angular/youtube-player';


@NgModule({
  declarations: [BlogsComponent, ViewAllBlogsComponent, BlogContentComponent],
  imports: [
    CommonModule,
    BlogsRoutingModule,
    AppCommonModule,
    YouTubePlayerModule
  ],
  providers:[]
})
export class BlogsModule { }
